import { useEffect, useState } from 'react';
import React from 'react';
import { useParams } from 'react-router-dom';
import { useMenusActions } from '../../states/menus/menu.actions';
import { IArea, IConteudo, IMenu, ISecao } from '../../commons/types/base';
import { Grid2, Typography, Collapse, IconButton } from '@mui/material';
import { GridBackground, TypographyDesc } from '../Acoes';
import Consultor from '../Home/Components/Consultor';
import Breadcrumb from '../../components/Breadcrumb';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { useTranslation } from '../../commons/useTranslasion';
import { esES, ptBR } from '@mui/material/locale';

export function createHTMLFromString(htmlString: any) {
  return <div dangerouslySetInnerHTML={{ __html: htmlString }} />;
}

interface IParams {
  id?: string;
  secaoId?: string;
  menuId?: string;
}

const ConteudoComponent: React.FC = () => {
  const { translate, language } = useTranslation();
  const lang = language ?? "pt-br";
  let locale = ptBR;
  switch (lang.slice(0, 2)) {
    case "es":
      locale = esES
      break;
  }
  
  const { id, secaoId } = useParams<IParams>();
  const [conteudo, setConteudo] = useState<IConteudo>();
  const [area, setArea] = useState<IArea>();
  const [secao, setSecao] = useState<ISecao>();
  const [expanded, setExpanded] = useState(false);

  const menusActions = useMenusActions();

  useEffect(() => {
    menusActions
      .get()
      .then((d) => {
        let menus: IMenu = d.resultado;

        if (secaoId != undefined) {
          const secao = menus.secoes.find((f) => f.id == Number(secaoId));
          const area = menus.areas.find((f) => f.id == secao?.idArea!);
          setArea(area);
          setSecao(secao);
        }

        let conteudo = menus.conteudos.find((f) => f.id == Number(id));
        setConteudo(conteudo);
      })
      .catch(() => {
      });
  }, [id]);

  const breadcrumbContent = conteudo?.titulo ? {
    titulo: conteudo.titulo,
    link: window.location.pathname
  } : undefined;

  return (
    <>
      <GridBackground container direction="column" spacing={0} sx={{ minHeight: '90vh' }}>
        <Consultor />

        <Grid2 size={{ xs: 12 }}>
          <Breadcrumb
            conteudo={breadcrumbContent}
          />
        </Grid2>

        {secaoId != undefined && (
          <Grid2 size={{ xs: 12 }} sx={{ paddingBottom: '10px' }}>
            <IconButton
              aria-label="expand"
              size="small"
              onClick={() => setExpanded(!expanded)}
            >
              {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </IconButton>
            <Typography variant="h5" sx={{ display: 'inline-block', marginLeft: '10px' }}>Seção: {secao?.nome}</Typography>
            <Collapse in={expanded} timeout="auto" unmountOnExit>
              <Typography variant="body1" sx={{ padding: '10px' }}>
                {createHTMLFromString(area?.descricao)}
              </Typography>
            </Collapse>
          </Grid2>
        )}

        <Grid2 size={{ xs: 12 }} sx={{ paddingBottom: '30px' }}>
          <Typography variant="h1">{conteudo?.titulo}</Typography>
        </Grid2>

        <Grid2 size={{ xs: 12 }} sx={{ paddingBottom: '10px' }}>
          <TypographyDesc variant="body1">
            {createHTMLFromString(conteudo?.texto)}
          </TypographyDesc>
        </Grid2>

        {(conteudo?.tbAnexosConteudo?.length ?? 0) > 0 && (
          <>
            <Grid2 size={{ xs: 12 }}>
              <Typography variant="h5">{translate('anexos')}</Typography>
            </Grid2>

            <Grid2 size={{ xs: 12 }}>
              {conteudo?.tbAnexosConteudo?.map((c: any, i: number) => (
                <Typography
                  key={i}
                  sx={{ padding: '10px', display: 'block' }}
                  variant="caption"
                >
                  <a href={c.anexo} target="_blank" rel="noopener noreferrer">
                    {i + 1}º - {translate('anexo')}
                  </a>
                </Typography>
              ))}
            </Grid2>
          </>
        )}
      </GridBackground>
    </>
  );
};

export default ConteudoComponent;
